import { config, IJsonRpcResponse } from "../api";

interface IChangePaymentMethodResponse extends IJsonRpcResponse {
    result: {
        success: boolean;
        message: string;
    }
}

export const changePaymentMethod = async (
    companyProfileID: number,
    paymentMethod: string
) => {
    const params = {
        companyProfileID,
        paymentMethod
    };
    const authToken = config.authToken;
    const res = await fetch(`${config.url}/changePaymentMethod`, {
        body: JSON.stringify(params),
        headers: {
            'Authorization': 'Bearer ' + authToken,
            'Content-Type': 'application/json'
        },
        method: 'post',
        mode: 'cors'
    });
    const body: IChangePaymentMethodResponse = await res.json();
    return body.result;
};
